if (!customElements.get('cart-b-recommendations')) {
  class CartBRecommendations extends HTMLElement {
    connectedCallback() {
      this.initSlider();
    }

    disconnectedCallback() {
      this.destroySlider();
    }

    initSlider() {
      if (typeof Swiper === 'undefined' || this.slider) return;

      const sliderElement = this.querySelector('.cart-best-seller-recommendations__body');
      if (!sliderElement || this.querySelectorAll('.swiper-slide').length === 0) return;

      this.slider = new Swiper(sliderElement, {
        threshold: 3,
        slidesPerView: 'auto',
        spaceBetween: 6,
        slidesPerGroupAuto: true,
        grabCursor: true,
        resistanceRatio: 0.72,
        watchOverflow: true,
        observer: true,
        observeParents: true
      });
    }

    destroySlider() {
      if (this.slider?.destroy) this.slider.destroy(true, true);
      this.slider = null;
    }
  }

  customElements.define('cart-b-recommendations', CartBRecommendations);
}
